import { useNeedAllowance } from 'src/hooks/v3/useNeedAllowance';
import {
  IDerivedMintInfo,
  useMintState,
  useMintActionHandlers
} from 'src/state/mintStore';
import { Currency, Field } from '@cryptoalgebra/kim-sdk';
import { useEffect, useMemo } from 'react';
import { VStack, Text } from '@chakra-ui/react';
import EnterAmountCard from '@app/screens/liquidity/AddLiquidityV3/components/EnterAmountsCard';

interface EnterAmountsProps {
  currencyA: Currency | undefined;
  currencyB: Currency | undefined;
  mintInfo: IDerivedMintInfo;
}

const EnterAmounts = ({
  currencyA,
  currencyB,
  mintInfo
}: EnterAmountsProps) => {
  const { independentField, typedValue } = useMintState();

  const { onFieldAInput, onFieldBInput } = useMintActionHandlers(
    mintInfo.noLiquidity
  );

  const formattedAmounts = {
    [independentField]: typedValue,
    [mintInfo.dependentField]:
      mintInfo.parsedAmounts[mintInfo.dependentField]?.toSignificant(6) ?? ''
  };

  useEffect(() => {
    return () => {
      onFieldAInput('');
      onFieldBInput('');
    };
  }, [onFieldAInput, onFieldBInput]);

  return (
    <>
      <VStack w="100%">
        <EnterAmountCard
          currency={currencyA}
          value={formattedAmounts[Field.CURRENCY_A]}
          handleChange={value => onFieldAInput(value)}
          isDisabled={mintInfo.depositADisabled}
        />
        {mintInfo.depositADisabled && (
          <Text fontSize="12px" color="neutral.400">
            For selected range this deposit is disabled
          </Text>
        )}
      </VStack>
      <VStack w="100%">
        <EnterAmountCard
          currency={currencyB}
          value={formattedAmounts[Field.CURRENCY_B]}
          handleChange={value => onFieldBInput(value)}
          isDisabled={mintInfo.depositBDisabled}
        />
        {mintInfo.depositBDisabled && (
          <Text fontSize="12px" color="neutral.400">
            For selected range this deposit is disabled
          </Text>
        )}
      </VStack>
    </>
  );
};

export default EnterAmounts;
